/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: SrXOXPt7amu2
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicFormElement.module.css"; // plasmic-import: SrXOXPt7amu2/css

createPlasmicElementProxy;

export const PlasmicFormElement__VariantProps = new Array("status");

export const PlasmicFormElement__ArgProps = new Array(
  "formInputComponent",
  "name",
  "required",
  "label",
  "showHelperText",
  "helperText",
  "showFormElement"
);

const $$ = {};

function PlasmicFormElement__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          required: false,
          showHelperText: true,
          showFormElement: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.status
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"formElement"}
      data-plasmic-override={overrides.formElement}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.formElement
      )}
    >
      <div
        data-plasmic-name={"labelWrapper"}
        data-plasmic-override={overrides.labelWrapper}
        className={classNames(projectcss.all, sty.labelWrapper, {
          [sty.labelWrapperstatus_normal]: hasVariant(
            $state,
            "status",
            "normal"
          )
        })}
      >
        <label
          data-plasmic-name={"label"}
          data-plasmic-override={overrides.label}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.label,
            {
              [sty.labelstatus_disabled]: hasVariant(
                $state,
                "status",
                "disabled"
              ),
              [sty.labelstatus_error]: hasVariant($state, "status", "error"),
              [sty.labelstatus_normal]: hasVariant($state, "status", "normal")
            }
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.label;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "label";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </label>
      </div>
      <div
        data-plasmic-name={"slotWrapper"}
        data-plasmic-override={overrides.slotWrapper}
        className={classNames(projectcss.all, sty.slotWrapper)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.formInputComponent
        })}
      </div>
      {(() => {
        try {
          return $props.showHelperText;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"helperTextWrapper"}
          data-plasmic-override={overrides.helperTextWrapper}
          className={classNames(projectcss.all, sty.helperTextWrapper, {
            [sty.helperTextWrapperstatus_normal]: hasVariant(
              $state,
              "status",
              "normal"
            )
          })}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text,
              {
                [sty.textstatus_disabled]: hasVariant(
                  $state,
                  "status",
                  "disabled"
                ),
                [sty.textstatus_error]: hasVariant($state, "status", "error"),
                [sty.textstatus_normal]: hasVariant($state, "status", "normal")
              }
            )}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.helperText;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "Helper text.";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  formElement: [
    "formElement",
    "labelWrapper",
    "label",
    "slotWrapper",
    "helperTextWrapper",
    "text"
  ],

  labelWrapper: ["labelWrapper", "label"],
  label: ["label"],
  slotWrapper: ["slotWrapper"],
  helperTextWrapper: ["helperTextWrapper", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFormElement__ArgProps,
          internalVariantPropNames: PlasmicFormElement__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFormElement__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "formElement") {
    func.displayName = "PlasmicFormElement";
  } else {
    func.displayName = `PlasmicFormElement.${nodeName}`;
  }
  return func;
}

export const PlasmicFormElement = Object.assign(
  // Top-level PlasmicFormElement renders the root element
  makeNodeComponent("formElement"),
  {
    // Helper components rendering sub-elements
    labelWrapper: makeNodeComponent("labelWrapper"),
    label: makeNodeComponent("label"),
    slotWrapper: makeNodeComponent("slotWrapper"),
    helperTextWrapper: makeNodeComponent("helperTextWrapper"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicFormElement
    internalVariantProps: PlasmicFormElement__VariantProps,
    internalArgProps: PlasmicFormElement__ArgProps
  }
);

export default PlasmicFormElement;
/* prettier-ignore-end */
